import React, { memo } from "react";
import { Body } from "@vds3/typography";
import { createPortal } from "react-dom";
import { VCG_CMP } from "../../Pages/CustomizeOrder/containers/constants";
import { VCG_URL } from "../../containers/APIurls";
const VcgBannerHeader = memo((props) => {
    const handleVcgNavigation = (e) => {
        e.stopPropagation();
        if(e.target.id === "personal-nav"){
            let url = VCG_URL || "https://www.verizon.com/home/internet/#checkAvailability";
            window.location.href = url + `?cmp=${decodeURIComponent(props?.cmp)}`;;
        }
    }
    let targetDOMNode = document.getElementById("vcg-navigation-bar");
    return createPortal(
        <>
            <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem", marginLeft:"0.9rem"}} id="vcg-navigator" onClick={(e)=>handleVcgNavigation(e)}>
                <Body bold id="personal-nav">Personal</Body>
                <div class="vertical-line"></div>
                <Body id="business-nav">Business</Body>
            </div>
        </>,
        targetDOMNode
    )
})
export default VcgBannerHeader;